// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"891":"af56ef64","949":"7e591849"}[chunkId] + ".chunk.js";
};